import { render, staticRenderFns } from "./oldstuff.vue?vue&type=template&id=48b1faf6"
import script from "./oldstuff.vue?vue&type=script&lang=js"
export * from "./oldstuff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports